$(function() {
	$('.js-account-wishlist-modal').validate({
        submitHandler: function(form) {
            $(form).find('[type="submit"]')
                .prop('disabled', true)
                .addClass('is-loading');

            form.submit();
        }
	});
});